import { render, staticRenderFns } from "./DeleteButtonWithMessage.vue?vue&type=template&id=0d1dfd11&"
import script from "./DeleteButtonWithMessage.vue?vue&type=script&lang=ts&"
export * from "./DeleteButtonWithMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports